import type { Terminology } from '@servicetim/shared';

/**
 * Words the portal uses for work items, resolved from `project.settings.terminology`
 * (unit 11: "issue" | "request" | "task"). Every label a screen shows comes from here so a
 * project that calls its items "tasks" never sees the word "request".
 */
export interface TerminologyLabels {
  singular: string;
  plural: string;
  /** Call to action on the help center tile / new request page. */
  create: string;
  /** "My requests" / "My issues" / "My tasks". */
  mine: string;
  /** Empty state: "You have not raised any requests yet." */
  noneYet: string;
}

const LABELS: Record<Terminology, TerminologyLabels> = {
  request: {
    singular: 'request',
    plural: 'requests',
    create: 'Raise a request',
    mine: 'My requests',
    noneYet: 'You have not raised any requests yet.',
  },
  issue: {
    singular: 'issue',
    plural: 'issues',
    create: 'Create an issue',
    mine: 'My issues',
    noneYet: 'You have not created any issues yet.',
  },
  task: {
    singular: 'task',
    plural: 'tasks',
    create: 'Add a task',
    mine: 'My tasks',
    noneYet: 'You have not added any tasks yet.',
  },
};

export const DEFAULT_TERMINOLOGY: Terminology = 'request';

export function terminologyLabels(terminology: Terminology | null | undefined): TerminologyLabels {
  return LABELS[terminology ?? DEFAULT_TERMINOLOGY];
}

/** "Request", "Issue" for headings. */
export const capitalize = (word: string): string =>
  word.length === 0 ? word : `${word[0]?.toUpperCase() ?? ''}${word.slice(1)}`;
